import { AlertDialog as BaseAlertDialog } from '@base-ui/react';
import { useState } from 'react';

export const useHandle = <Payload>() => {
  const [handle] = useState(() => BaseAlertDialog.createHandle<Payload>());

  return handle;
};
